import { createVNode as l, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MaleFilledStandard.js";
import i from "../components/PfIcon.js";
const r = (e, t) => {
  const a = {
    ...e,
    ...t.attrs
  };
  return l(i, o(a, {
    icon: d
  }), null);
};
r.displayName = "MaleFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
